import React, { Component } from "react";
import { EditHeadComponent } from "./../BioAndSubEditComponent";
import { connect } from "react-redux";
import { Col, Button } from "react-bootstrap";
import InputField from "./../../../components/InputFieldComponent";
import { TutorSettingAction } from "./../../../redux/actions";
import { updateTutorSettings } from "../../../apis/tutors";

class ProfileBioSetting extends Component {
  constructor() {
    super();
    this.state = {
      editMode: "",
      tutorSettingDataState: {},
      taglineReq: false,
      bioReq: false,
      teachingStyleReq: false,
    };
  }

  componentDidMount = () => {
    const { tutorSettingData } = this.props;
    const { tutorSettingDataState } = this.state;
    this.setState({
      tutorSettingDataState: { ...tutorSettingData },
    });
  };
  componentDidUpdate = (prevProps) => {
    const { tutorSettingData } = this.props;
    const { tutorSettingDataState } = this.state;
    if (
      (!tutorSettingDataState?.userId && tutorSettingData?.userId) ||
      prevProps?.tutorSettingData?.userId !== tutorSettingData?.userId
    ) {
      this.setState({
        tutorSettingDataState: { ...tutorSettingData },
      });
    }
  };
  getTextInput = (e, textLimit, req) => {
    let { tutorSettingDataState } = this.state;
    this.setState({
      [req]: true,
    });
    if (tutorSettingDataState.tutorDetails) {
      tutorSettingDataState.tutorDetails[e.target.name] = e.target.value;
      return e.target.value.length <= textLimit
        ? this.setState({
            tutorSettingDataState,
          })
        : null;
    } else {
      tutorSettingDataState.tutorDetails = {};
      tutorSettingDataState.tutorDetails[e.target.name] = e.target.value;
      return e.target.value.length <= textLimit
        ? this.setState({
            tutorSettingDataState,
          })
        : null;
    }
  };
  onSave = () => {
    let { tutorSettingDataState } = this.state;
    this.props.TutorSettingStoreData(tutorSettingDataState);
    let updateTutorObj = { ...tutorSettingDataState };
    let tutorDetails = { ...updateTutorObj.tutorDetails };
    delete updateTutorObj.tutorDetails;
    updateTutorObj = { ...updateTutorObj, ...tutorDetails };
    let updateSettingParam = {
      updateSetting: {
        bio: updateTutorObj.bio,
        tagline: updateTutorObj.tagline,
        teachingStyle: updateTutorObj.teachingStyle,
      },
    };
    updateTutorSettings(updateSettingParam)
      .then((res) => {
        this.setState({
          loader: false,
        });
        this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub");
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
  };
  onCancel = () => {
    this.props.history.goBack();
  };
  render() {
    const {
      tutorSettingDataState,
      taglineReq,
      bioReq,
      teachingStyleReq,
    } = this.state;
    return (
      <div className="flex-col-center">
        <EditHeadComponent
          settingTitle={"Bio and lesson description"}
          settingDescription={
            "Tell student and parents about yourself and describe your lessons to inspire students to take your lesson."
          }
          isBorder={false}
          backToprofileView={() =>
            this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub")
          }
        />
        <Col
          lg={9}
          md={9}
          sm={12}
          xs={12}
          className="ProfileBio-of-setting-div"
        >
          <InputField
            InputHeadTitle="Profile tag"
            inputDes="Your profile tagline should highlight what makes you the ideal tutor for lesson"
            style={{
              height: "65px",
              fontFamily: "OpenSans, Arial, sans-serif",
              fontSize: "16px",
              headTitle: {
                color: "#0f0f0f",
                fontSize: "18px",
                marginBottom: "5px",
                fontWeight: "500",
                fontFamily: "CircularStdMedium, Arial, sans-serif",
              },
              borderGroup:
                !tutorSettingDataState?.tutorDetails?.tagline && taglineReq
                  ? "1px solid #fa4a4a"
                  : null,
              backgroundColor:
                !tutorSettingDataState?.tutorDetails?.tagline && taglineReq
                  ? "#fff1f1"
                  : null,
            }}
            required={
              !tutorSettingDataState?.tutorDetails?.tagline && taglineReq
            }
            name="tagline"
            value={
              tutorSettingDataState?.tutorDetails?.tagline
                ? tutorSettingDataState?.tutorDetails?.tagline
                : ""
            }
            textLimit={75}
            onChange={(e) => this.getTextInput(e, 75, "taglineReq")}
          />
          {!tutorSettingDataState?.tutorDetails?.tagline && taglineReq ? (
            <div
              style={{ color: "#fa4a4a", fontSize: "14px", fontWeight: "bold" }}
            >
              Please add a tagline to your profile
            </div>
          ) : (
            ""
          )}
          <div style={{ marginBottom: "50px" }} />
          <InputField
            InputHeadTitle="About Yourself"
            inputDes="A brief description, your tutoring journey and what makes you unique"
            textArea={true}
            name="bio"
            style={{
              height: "174px",
              fontFamily: "OpenSans, Arial, sans-serif",
              fontSize: "16px",
              headTitle: {
                color: "#0f0f0f",
                fontSize: "18px",
                marginBottom: "5px",
                fontWeight: "500",
                fontFamily: "CircularStdMedium, Arial, sans-serif",
              },
              borderGroup:
                !tutorSettingDataState?.tutorDetails?.bio && bioReq
                  ? "1px solid #fa4a4a"
                  : null,
              backgroundColor:
                !tutorSettingDataState?.tutorDetails?.bio && bioReq
                  ? "#fff1f1"
                  : null,
            }}
            value={
              tutorSettingDataState?.tutorDetails?.bio
                ? tutorSettingDataState?.tutorDetails?.bio
                : ""
            }
            required={!tutorSettingDataState?.tutorDetails?.bio && bioReq}
            textLimit={750}
            onChange={(e) => this.getTextInput(e, 750, "bioReq")}
          />
          {!tutorSettingDataState?.tutorDetails?.bio && bioReq ? (
            <div
              style={{ color: "#fa4a4a", fontSize: "14px", fontWeight: "bold" }}
            >
              Please add a bio to your profile
            </div>
          ) : (
            ""
          )}
          <div style={{ marginBottom: "50px" }} />
          <InputField
            InputHeadTitle="Tell us about your teaching style"
            inputDes="your description should help students imagine what it will like to study with you."
            textArea={true}
            name="teachingStyle"
            style={{
              height: "93px",
              fontFamily: "OpenSans, Arial, sans-serif",
              fontSize: "16px",
              headTitle: {
                color: "#0f0f0f",
                fontSize: "18px",
                marginBottom: "5px",
                fontWeight: "500",
                fontFamily: "CircularStdMedium, Arial, sans-serif",
              },
              borderGroup:
                !tutorSettingDataState?.tutorDetails?.teachingStyle &&
                teachingStyleReq
                  ? "1px solid #fa4a4a"
                  : null,
              backgroundColor:
                !tutorSettingDataState?.tutorDetails &&
                teachingStyleReq?.teachingStyle
                  ? "#fff1f1"
                  : null,
            }}
            value={
              tutorSettingDataState?.tutorDetails?.teachingStyle
                ? tutorSettingDataState?.tutorDetails?.teachingStyle
                : ""
            }
            required={
              !tutorSettingDataState?.tutorDetails?.teachingStyle &&
              teachingStyleReq
            }
            textLimit={350}
            onChange={(e) => this.getTextInput(e, 350, "teachingStyleReq")}
          />
          {!tutorSettingDataState?.tutorDetails?.teachingStyle &&
          teachingStyleReq ? (
            <div
              style={{ color: "#fa4a4a", fontSize: "14px", fontWeight: "bold" }}
            >
              Please add a teachingStyle to your profile
            </div>
          ) : (
            ""
          )}
          <div style={{ marginBottom: "20px" }} />
          <hr />
          <div style={{ marginBottom: "20px" }} />
        </Col>
        <Col lg={10} md={10} sm={12} xs={12}>
          <Button
            className="green-Button"
            style={{
              width: "126px",
              height: "45px",
              borderRadius: "5px",
              backgroundColor: "#2cb46d",
              fontFamily: "CircularStdMedium, Arial, sans-serif",
            }}
            onClick={this.onSave}
          >
            Save
          </Button>
          <Button
            className="green-unfill-btn"
            style={{
              width: "126px",
              height: "45px",
              borderRadius: "5px",
              border: "solid 2px #2cb46d",
              marginLeft: "20px",
              fontFamily: "CircularStdMedium, Arial, sans-serif",
            }}
            onClick={this.onCancel}
          >
            Cancel
          </Button>
        </Col>
        <div style={{ marginBottom: "50px" }} />
      </div>
    );
  }
}

const mapDispatchToprops = (dispatch) => {
  return {
    TutorSettingStoreData: (payload) =>
      dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
  };
};

const mapStateToProps = (state) => {
  const {
    TutorSettingReducer: { tutorSettingData },
  } = state;
  return {
    tutorSettingData,
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(ProfileBioSetting);
